import { DealTransactionType } from 'modules/core/enums';
import { useCallback } from 'react';

interface IGetOverrideAprParams {
  balloonToggle: boolean;
  isShopByCallbackMode: boolean;
  dealSourceOverrideApr?: number | null;
  dealSourceTransactionType?: string;
}

export const useFormOverrideApr = (getValues: () => any) => {
  const hasFormOverrideApr = useCallback(() => {
    const val = getValues()?.preferences?.overrideApr;
    const parsed = Number(val);

    return val != null && val !== '' && Number.isFinite(parsed);
  }, [getValues]);

  const getFormOverrideApr = useCallback(() => Number(getValues()?.preferences?.overrideApr), [getValues]);

  const getOverrideApr = useCallback(
    ({
      balloonToggle,
      isShopByCallbackMode,
      dealSourceOverrideApr,
      dealSourceTransactionType,
    }: IGetOverrideAprParams) => {
      if (isShopByCallbackMode || balloonToggle || dealSourceTransactionType === DealTransactionType.BALLOON_PAYMENT) {
        return undefined;
      }

      if (hasFormOverrideApr()) return getFormOverrideApr();

      // Intentional falsy check: 0 is not a valid DealSource override APR and should be treated as absent.
      return dealSourceOverrideApr || undefined;
    },
    [hasFormOverrideApr, getFormOverrideApr],
  );

  return { hasFormOverrideApr, getFormOverrideApr, getOverrideApr };
};
